// extracted by mini-css-extract-plugin
export default {"whoWeAre":"WhoWeAre_whoWeAre__98xHD"};